<template>
    <div class="update-card-modal">
        <base-modal-close @close-modal="closeUpdateModal" />
        <p class="modal-title">
            Update Payment Method
        </p>
        <update-billing-handler
            v-slot:default="{
                updatePaymentMethod,
                cardProcessing
            }"
            @update-finished="closeUpdateModal"
        >
            <card-form
                :update="true"
                :update-processing="cardProcessing"
                @stripe-success="paymentMethod => updatePaymentMethod(paymentMethod)"
                @cancel="closeUpdateModal"
            />
       </update-billing-handler>
    </div>
</template>

<script>
import CardForm from '@/components/Billing/CardForm';
import UpdateBillingHandler from '@/components/Billing/UpdateBillingHandler';
import modal from '@/mixins/modal';
import { mapMutations } from 'vuex';

export default {
    components: {
        CardForm,
        UpdateBillingHandler,
    },

    mixins: [modal],

    methods: {
        ...mapMutations(['changeUIState']),

        /**
         * Closes udpdate modal
         */
        closeUpdateModal() {
            this.changeUIState({ isUpdateModalVisible: false });
        },
    },
};
</script>
